import { useTranslation } from 'react-i18next';
import { useToast } from '../../context/ToastContext';

const icons = {
  info: (
    <svg
      className="w-5 h-5 flex-shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  success: (
    <svg
      className="w-5 h-5 flex-shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  warning: (
    <svg
      className="w-5 h-5 flex-shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  ),
  error: (
    <svg
      className="w-5 h-5 flex-shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
};

const styles = {
  info: 'bg-white dark:bg-slate-800 border-primary-200 dark:border-primary-700 text-slate-800 dark:text-slate-100',
  success:
    'bg-white dark:bg-slate-800 border-accent-200 dark:border-accent-700 text-slate-800 dark:text-slate-100',
  warning:
    'bg-white dark:bg-slate-800 border-warning-200 dark:border-warning-700 text-slate-800 dark:text-slate-100',
  error:
    'bg-white dark:bg-slate-800 border-danger-200 dark:border-danger-700 text-slate-800 dark:text-slate-100',
};

const iconColor = {
  info: 'text-primary-600 dark:text-primary-300',
  success: 'text-accent-600 dark:text-accent-300',
  warning: 'text-warning-600 dark:text-warning-300',
  error: 'text-danger-600 dark:text-danger-300',
};

const ToastContainer = () => {
  const { t } = useTranslation();
  const { toasts, dismissToast } = useToast();
  if (!toasts.length) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-[60] flex flex-col gap-2 max-w-[calc(100vw-2rem)] sm:max-w-sm"
      role="region"
      aria-label={t('ui.notifications')}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-start gap-3 p-3 pr-2 rounded-lg border shadow-lg ${styles[t.type] || styles.info}`}
          role="alert"
        >
          <span className={iconColor[t.type] || iconColor.info}>{icons[t.type] || icons.info}</span>
          <div className="flex-1 text-sm leading-snug">{t.message}</div>
          <button
            type="button"
            onClick={() => dismissToast(t.id)}
            className="text-slate-400 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 transition-colors"
            aria-label={t('common.close')}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
